// extracted by mini-css-extract-plugin
export default {"burger":"BurgerIcon_burger__HsQ4e"};